import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import type { ThunkDependencies } from "single-spa/store/thunk-dependencies";
import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";

export const syncIntegrationsThunk =
    () => async (_dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        if (!salesSettingsHelper.isCrmIntegrationsEnabled()) {
            return;
        }

        try {
            await deps.si.api.management.syncIntegrations();
        } catch (error) {
            if (error?.name !== "AbortError") {console.error(error);}
        }
    };
